import React from "react";
import styled from "styled-components";

const Tabs = ({
  options,
  activeTab,
  setActiveTab,
  counts = {},
  className = "",
}) => {
  const handleChange = (tabKey) => {
    setActiveTab(tabKey);
  };

  const renderTabs = () => {
    return options.map((tab) => {
      const isActive = tab.tabKey === activeTab;
      return (
        <Tab
          id="tab"
          key={tab.value}
          className={isActive ? "active" : ""}
          onClick={() => handleChange(tab.tabKey)}
        >
          <div className="title">
            <p>{tab.label}</p>
            <span>{counts[tab.value]}</span>
          </div>

          {isActive && <Divider />}
        </Tab>
      );
    });
  };

  return <Wrapper className={className}>{renderTabs()}</Wrapper>;
};

const Wrapper = styled.div`
  width: 100%;
  height: 52px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f2f4;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const Tab = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 16px;
  display: flex;
  flex-direction: column;

  div.title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    p {
      margin-right: 8px;
    }
  }

  p,
  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #9a9ea8;
  }

  &.active {
    p {
      color: #26282b;
    }
    span {
      color: #004fec;
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: #515458;
  border-radius: 5px;
  position: relative;
  top: 14px;
`;

export default Tabs;
